import React, { useState, useEffect } from 'react'
import { motion } from 'motion/react'
import type { FieldValues } from '../../fieldTypes'

export function TextLetterByLetter({ values = {} }: { values?: FieldValues }) {
  const [key, setKey] = useState(0)
  const text = values.text ?? 'Nimble Labs'
  const staggerDelay = values.staggerDelay ?? 0.05
  const stiffness = values.stiffness ?? 300
  const damping = values.damping ?? 20
  const initialY = values.initialY ?? 20

  useEffect(() => {
    const interval = setInterval(() => setKey((k) => k + 1), 3000)
    return () => clearInterval(interval)
  }, [])

  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: { staggerChildren: staggerDelay },
    },
  }

  const letter = {
    hidden: { opacity: 0, y: initialY },
    show: {
      opacity: 1,
      y: 0,
      transition: { type: 'spring', stiffness, damping },
    },
  }

  return (
    <div className="flex items-center justify-center h-full">
      <motion.div
        key={key}
        variants={container}
        initial="hidden"
        animate="show"
        className="flex"
      >
        {text.split('').map((char, i) => (
          <motion.span
            key={i}
            variants={letter}
            className="text-lg font-bold text-gray-800"
          >
            {char === ' ' ? '\u00A0' : char}
          </motion.span>
        ))}
      </motion.div>
    </div>
  )
}
